module.exports = __webpack_public_path__ + "01ea978f/img/placeholder.888fcd0b.svg";